// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.stepper {

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
}

.step {
  width: 100%;
  height: 100%;
}



.step-title {

}

.form {

}

.label {

}

.form-buttons {
  width: 100%;
}

.form-button {

}

.input-field {

}

.checkboxes-block {

}

.checkbox-field {

}

.checkbox-name {

}

.radiobutton-block {

}

.radiobutton-field {

}
.radiobutton-field input {
  opacity: 0;
}

.radiobutton-name {

}



/* FIRST STEP */
.step.step-0 {
}

.step-0 .step-title {

}

.step.step-0 .form {
  width: 100%;
}

.step.step-0 .form label {
  width: 100%;
  margin-bottom: 36px;
  display: flex;
  justify-content: center;
}

.step.step-0 .form .label {
  width: 100%;
  font-size: 14px;
  padding-bottom: 6px;
}

.step.step-0 .form input {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 6px;
}

.step.step-0 .form-buttons {
  display: flex;
  justify-content: center;
}

.step.step-0 .form button {
  height: 46px !important;
  width: 114px !important;
  background-color: rgba(156, 39, 176, 1);
  border: 1px solid rgba(156, 39, 176, 1);
  border-radius: 3px;
  padding: 6px;
  color: #FFFFFF;

  font-size: 15px;
  font-weight: 700;
  line-height: 46px;
  margin-top: -18px;
}

/*  */

.step-1>div {
  height: 600px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/widget.css"],"names":[],"mappings":";;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;EAEnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;;AAIA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;EACE,WAAW;AACb;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;AACA;EACE,UAAU;AACZ;;AAEA;;AAEA;;;;AAIA,eAAe;AACf;AACA;;AAEA;;AAEA;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uCAAuC;EACvC,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;EACZ,cAAc;;EAEd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,KAAK;;AAEL;EACE,aAAa;EACb,WAAW;AACb","sourcesContent":["\n\n.stepper {\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  width: 100%;\n  height: 100%;\n}\n\n.step {\n  width: 100%;\n  height: 100%;\n}\n\n\n\n.step-title {\n\n}\n\n.form {\n\n}\n\n.label {\n\n}\n\n.form-buttons {\n  width: 100%;\n}\n\n.form-button {\n\n}\n\n.input-field {\n\n}\n\n.checkboxes-block {\n\n}\n\n.checkbox-field {\n\n}\n\n.checkbox-name {\n\n}\n\n.radiobutton-block {\n\n}\n\n.radiobutton-field {\n\n}\n.radiobutton-field input {\n  opacity: 0;\n}\n\n.radiobutton-name {\n\n}\n\n\n\n/* FIRST STEP */\n.step.step-0 {\n}\n\n.step-0 .step-title {\n\n}\n\n.step.step-0 .form {\n  width: 100%;\n}\n\n.step.step-0 .form label {\n  width: 100%;\n  margin-bottom: 36px;\n  display: flex;\n  justify-content: center;\n}\n\n.step.step-0 .form .label {\n  width: 100%;\n  font-size: 14px;\n  padding-bottom: 6px;\n}\n\n.step.step-0 .form input {\n  width: 100%;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 6px;\n}\n\n.step.step-0 .form-buttons {\n  display: flex;\n  justify-content: center;\n}\n\n.step.step-0 .form button {\n  height: 46px !important;\n  width: 114px !important;\n  background-color: rgba(156, 39, 176, 1);\n  border: 1px solid rgba(156, 39, 176, 1);\n  border-radius: 3px;\n  padding: 6px;\n  color: #FFFFFF;\n\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 46px;\n  margin-top: -18px;\n}\n\n/*  */\n\n.step-1>div {\n  height: 600px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
